import 'satellite-polyfills';

import { createApp } from 'vue';

import initSentry from '@satellite/plugins/sentry';

import App from './App.vue';
import router from './router';
import config from './config';

import { loadFonts } from './plugins/webfontloader';
import vuetify from './plugins/vuetifyPlugin';

loadFonts();

const initApp = async () => {
  const app = createApp(App);

  app.use(router);
  app.use(vuetify);

  initSentry(app, router, config);

  app.mount('#app');
};

initApp();
